export default __webpack_public_path__ + "static/media/peopleBannerPricing.123983d0.png";